import { render, staticRenderFns } from "./wordViewer.vue?vue&type=template&id=0b8af998"
import script from "./wordViewer.vue?vue&type=script&lang=js"
export * from "./wordViewer.vue?vue&type=script&lang=js"
import style0 from "./wordViewer.vue?vue&type=style&index=0&id=0b8af998&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports